// extracted by mini-css-extract-plugin
export var activityContainer = "_jp-0";
export var typingIndicatorContainer = "_jp-1";
export var typingIndicatorDot = "_jp-2";
export var wave = "_jp-3";